export default {"src":"/_next/static/media/BannerDefault.cc769fe1.svg","height":100,"width":414};